const MenuCashier = [];

export default MenuCashier;
